<template>
  <section class="content">
    <div class="form-steps-outer">
      <div class="col-xs-12 center-children-sm">
        <div class="btn btn-success" @click="newQuote">
          <i class="fa fa-plus"></i> New
        </div>
        <div class="btn btn-primary">
          <i class="fa fa-filter"></i> Filter
        </div>
        <div class="btn btn-info" @click="dataToShow = 'recentJobs'">
          <i class="fa fa-refresh"></i> Recent
        </div>
      </div>
    </div>
    <vuetable
      v-on:table-delete-request="handleDelete"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="getTableData"
      :tableTitle="getConst(locale, 'QUOTES_TABLE')"
      :fields="[
        { header: 'From', prop: item => item.fromLocation ? displayLocation(item.fromLocation) : '' },
        { header: 'To', prop: item => item.toLocation ? displayLocation(item.toLocation) : '' },
        { header: 'Container Type', prop: 'containerType' },
        { header: 'Account', prop: item => item.account ? displayParty(item.account) : '' }
      ]"
    ></vuetable>
  </section>
</template>
<script>
  import quotes from '../mixins/quotes'
  import vuetable from '../../helpers/VueTable.vue'
  export default {
    name: 'QuoteSearch',
    mixins: [quotes],
    components: {
      vuetable: vuetable
    },
    data () {
      return {
        search: '',
        dataToShow: 'recentJobs'
      }
    },
    computed: {
      matchesBySearch () {
        return this.search.trim().length ? this.quotes.filter((item) => {
          return JSON.stringify(item).toLowerCase().indexOf(this.search.toLowerCase()) > -1
        }) : this.quotes
      },
      quotes () {
        return this.$store.getters['quote/quotes']
      },
      recents () {
        return this.$store.getters['stats/recent']
      },
      recentJobs () {
        return this.recents.hasOwnProperty('job') ? this.recents.job : []
      },
      getTableData () {
        return this[this.dataToShow]
      }
    },
    methods: {
      handleEdit ({item, index}) {
        this.$router.push({name: 'Quote Form - edit', params: { id: item.id }})
      },
      handleDelete ({item, index}) {},
      newQuote () {
        this.$router.push({name: 'Add a new Quote'})
      },
      displayLocation (location) {
        let str = ''
        if (location.name) {
          str += location.name
        }
        if (location.subdivision) {
          str += `, ${location.subdivision}`
        }
        if (typeof location.country === 'object' && location.country !== null && location.country.hasOwnProperty('code')) {
          str += `, ${location.country.code}`
        }
        return str
      },
      displayParty (p) {
        return `${p.name} - ${p.code}`
      }
    }
  }
</script>

<style scoped>
  .input-group input {
    border-radius: 30px 0 0 30px;
  }
  .input-group .input-group-addon {
    border-radius: 0 30px 30px 0;
  }
  .center-children-sm > * {
    border-radius: 0;
  }
  @media (max-width: 768px) {
    .center-children-sm > * {
      width:33%;
    }
  }
</style>



// WEBPACK FOOTER //
// QuoteSearch.vue?d25fb05c